import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:scaffolder` from `@backstage/plugin-scaffolder` so `/create`
 * renders the portal's own template picker (ADR-0012). Only the template list
 * changes — see `VivictaScaffolderPage` for why the rest of the router stays
 * stock.
 *
 * Aliasing the plugin's own route ref keeps the "Create..." sidebar entry and
 * every `useRouteRef` call site pointing here, and `noHeader` suppresses the
 * `PluginHeader` the blueprint would otherwise stack above the page's own
 * branded `Header`.
 */
export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/create',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'scaffolder.root' }),
        loader: () =>
          import('./VivictaScaffolderPage').then(m => (
            <PageErrorBoundary title="Actions">
              <m.VivictaScaffolderPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
